import { IRole } from 'src/types';
import { fetch } from '../fetchWrapper/fetch';
import { API_URL } from 'src/constants';

export interface GetRolesResponse {
  data: IRole[];
}

export const getRoles = async (): Promise<GetRolesResponse> => {
  const uri = `${API_URL}/admin/roles`;

  const response = await fetch(uri);
  if (!response.ok) {
    throw new Error('Could not fetch roles');
  }
  const responseBody = await response.json();
  return responseBody;
};
